document.querySelectorAll('.template-product [data-add-btn]').forEach(button => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const targetBtn = document.querySelector('.shopify-product-form .add-to-cart-button');
    
    if (targetBtn) {
      // Scroll to the button smoothly
      targetBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Simulate a click after a slight delay (to allow scroll animation)
      setTimeout(() => {
        targetBtn.click();
      }, 500);
    }
  });
});

